import Filter, { FilterType } from 'src/constants/filter';
import Report, { REPORTS_WITH_PAGINATION } from 'src/constants/report';
import { FilterValues } from 'src/models/filterValues';

const isCorrectReport = (filterValues: FilterValues, reportName: string): reportName is keyof FilterValues => {
    return reportName in filterValues;
};

const isCorrectFilter = (
    filterValues: FilterValues,
    reportName: keyof FilterValues,
    filterName: string
): filterName is keyof FilterValues[keyof FilterValues] => {
    return filterName in filterValues[reportName];
};

export const resetPage = (state: FilterValues, filterName: Filter): void => {
    if (filterName === Filter.Page) {
        return;
    }
    REPORTS_WITH_PAGINATION.forEach((reportName) => {
        if (isCorrectReport(state, reportName) && !state[reportName]) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            state[reportName] = {};
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        state[reportName].page = 0;
    });
};

export const getNotIntersectingFilters = (currentFilters: Filter[], previouseFilters: Filter[]): Filter[] => {
    return currentFilters.filter((filterName) => !previouseFilters.includes(filterName));
};

export const isSpecificFilter = (
    filterValues: FilterValues,
    reportName: string,
    filterName: string
): reportName is keyof FilterValues =>
    Boolean(
        isCorrectReport(filterValues, reportName) &&
            isCorrectFilter(filterValues, reportName, filterName) &&
            filterValues[reportName][filterName] !== undefined
    );

export const getFilterValue = <F extends Filter>({
    filterValues,
    reportName,
    filterName,
}: {
    filterValues: FilterValues;
    reportName: Report;
    filterName: F;
}): FilterType[F] | null => {
    const filtersReportName: keyof FilterValues = isSpecificFilter(filterValues, reportName, filterName)
        ? reportName
        : 'common';
    if (
        isCorrectFilter(filterValues, filtersReportName, filterName) &&
        filterValues[filtersReportName][filterName] !== undefined
    ) {
        return filterValues[filtersReportName][filterName];
    }
    return null;
};
